import React from 'react';
import '../../../index.css';
function DeleteModal(props) {
  const { open, close, deleteContents, contentsNo } = props;

  return (
    <div
      className={open ? 'delete openModal modal' : 'modal'}
      style={{ zIndex: '9999' }}
    >
      {open ? (
        <section>
          <main>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontSize: 22,
                marginBottom: 5,
              }}
            >
              삭제 시 복구할 수 없습니다.
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: 22,
                marginBottom: 40,
              }}
            >
              정말 삭제하시겠습니까?
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <button
                className="rounded-button-g"
                style={{
                  fontWeight: 700,
                  color: 'black',
                  width: 173,
                  height: 54,
                  borderRadius: 50,
                  marginRight: 50,
                  fontSize: 22,
                }}
                onClick={close}
              >
                아니오
              </button>
              <button
                className="rounded-button-y"
                style={{
                  fontWeight: 700,
                  color: 'black',
                  width: 173,
                  height: 54,
                  borderRadius: 50,
                  fontSize: 22,
                }}
                onClick={() => {
                  deleteContents(contentsNo);
                }}
              >
                네
              </button>
            </div>
          </main>
        </section>
      ) : null}
    </div>
  );
}

DeleteModal.defaultProps = {
  contentsNo: 0,
};

export default DeleteModal;
